export enum AlertTypeEnum {
    RECENT = 'RECENT',
    SURGE = 'SURGE'
}

export enum AlertStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    EXPIRED = 'EXPIRED'
}
